import React, { useState } from "react";
import Style from "./SelectDelivery.module.scss";
import Button from "../../../Button/Button";
import { setDeliveryPostApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";

const SelectDelivery = ({ handleOk, cityID, orderID }) => {
  const [value, setValue] = useState("");
  const [time, setTime] = useState("");
  const [disable, setDisable] = useState(false);

  const sendDeliver = () => {
    setDisable(true);
    let info = {
      order_id: orderID,
      delivery_id: value,
      delivery_remaining_time: time,
    };
    setDeliveryPostApi(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setDisable(false);
      } else {
        errorToast(res.message);
        setDisable(false);
      }
    });
    handleOk();
  };
  return (
    <div className={Style.componentHolder}>
      <select
        onChange={(e) => setValue(e.target.value)}
        className={Style.selectDeliver}
        defaultValue={1}
      >
        <option className={Style.deliverName} value={1} disabled>
          پیک مورد نظر خودرا انتخاب کنید
        </option>
        {cityID.map((item) => {
          return (
            <option key={item.id} className={Style.deliverName} value={item.id}>
              {item.first_name + " " + item.last_name}
            </option>
          );
        })}
      </select>
      <label className={Style.setTime} htmlFor="time">
        :زمان تقریبی تا مقصد را وارد کنید
      </label>
      <input
        id={"time"}
        type={"text"}
        className={Style.remainTime}
        value={time}
        onChange={(e) => setTime(e.target.value)}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <Button
          Value={"تایید"}
          ClickHandler={sendDeliver}
          ClassBtn={"okBtn"}
          disabledprops={disable}
        />
        <Button Value={"بستن"} ClickHandler={handleOk} ClassBtn={"okBtn"} />
      </div>
    </div>
  );
};

export default SelectDelivery;
